import React from 'react';
import { Row, Col } from 'bootstrap';
import { OrderedMap, Map } from 'immutable';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import {
  ColumnProps,
  ListHeaderHeight,
} from 'shared/flux/stores/cuesheet.fullscreen/DisplayViewConstants';
import UserActions from 'flux/actions/UserActions';
import s3 from 'shared/constants/s3';

import { displayView } from 'shared/constants/Onboarding';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const { displayViewSelectColumn } = displayView;

const menuId = 'displayViewColumnSelector';

class ListHeader extends React.Component {
  constructor(props) {
    super(props);
    this._getPopoverNode = this._getPopoverNode.bind(this);

    this.state = {
      showColumnSelector: false,
    };
  }

  render() {
    const { columns, columnId } = this.props;

    let activeColumn = null;

    if (columns) {
      columns.forEach((col) => {
        if (col._id === columnId) activeColumn = col;
      });
    }

    const columnTitle = activeColumn
      ? activeColumn.title
      : 'Select your display column';

    const {
      numberColumnProps,
      titleColumnProps,
      timingColumnProps,
      dataColumnProps,
    } = ColumnProps;

    return (
      <Row style={{ height: ListHeaderHeight }} className="list-header">
        <Col {...numberColumnProps} className="number-column-header" />
        <Col {...titleColumnProps} className="title-column-header">
          Item
        </Col>
        <Col {...timingColumnProps} className="timings-column-header">
          <div className="column-header-text">Timings</div>
        </Col>
        <Col {...dataColumnProps} className="data-column-header">
          <div>
            <div
              className="column-header"
              onClick={() => this.setState({ showColumnSelector: true })}
            >
              <div className="column-header-text">{columnTitle}</div>
              {this._getPopoverNode()}
            </div>
          </div>
        </Col>
      </Row>
    );
  }

  _getPopoverNode() {
    const { columns, columnId, showOnboarding, user } = this.props;

    const { showColumnSelector } = this.state;

    if (!columns) return null;

    let items = OrderedMap({});

    columns.forEach((col) => {
      const { title, deleted, hidden } = col;
      if (deleted || hidden) return;
      items = items.set(
        col._id,
        Map({
          content: <span>{title}</span>,
          onClick: () => {
            if (showOnboarding) {
              UserActions.updateOnboarding(
                user.get('_id'),
                displayViewSelectColumn,
                true,
              );
            }
            FullScreenCuesheetActions.setDisplayViewColumn(col._id);
          },
        }),
      );
    });

    const configData = Map({
      id: menuId,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => this.setState({ showColumnSelector: true }),
      onHide: () => this.setState({ showColumnSelector: false }),
      items,
    });

    const onboardingNode =
      showOnboarding || !columnId ? (
        <div className="onboarding-wrapper">
          <img
            className="onboarding-arrow"
            src={s3.onboardingArrow}
            alt="onboarding-arrow"
          />
          <div className="text-wrapper">
            <div className="title">Select your display column above</div>
            <div className="description">
              You can choose one column from your show to dictate which content
              is shown on the right side of the screen.
            </div>
          </div>
        </div>
      ) : null;

    return (
      <div className="caret-right">
        <PopoverMenu
          className="cs-data-column-menu"
          config={configData}
          show={showColumnSelector}
        />
        {onboardingNode}
      </div>
    );
  }
}

export default ListHeader;
